<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Capital</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="blue lighten-3">
            <v-card-text>
              <h4 class="mt-0">Kurdistan Bank</h4>
              <h3 class="mt-0">{{ apiData.kurBalance | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="blue lighten-3">
            <v-card-text>
              <h4 class="mt-0">America Bank</h4>
              <h3 class="mt-0">{{ apiData.usaBalance | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="orange lighten-3">
            <v-card-text>
              <h4 class="mt-0">Our Loan On Customers</h4>
              <h3 class="mt-0">{{ apiData.ourLoanOnCustomer | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="red lighten-3">
            <v-card-text>
              <h4 class="mt-0">Customer Loan On Us</h4>
              <h3 class="mt-0">{{ apiData.customerLoanOnUs | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="red lighten-3">
            <v-card-text>
              <h4 class="mt-0">Supplier Loan On Us</h4>
              <h3 class="mt-0">{{ apiData.supplierLoanOnUs | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="green lighten-3">
            <v-card-text>
              <h4 class="mt-0">Capital</h4>
              <h3 class="mt-0">{{ apiData.capital | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  data() {
    return {
      apiData: {},
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    getData() {
      var token = localStorage.getItem('access_token')
      Axios.get('api/capital', { headers: { Authorization: 'Bearer ' + token } }).then((res) => {
        this.apiData = res.data
      })
    },
  },
}
</script>

<style scoped>

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/components/capital.vue